import Url from '@music/mobile-url';
import Request from './fetch';

const mockUserId = Url.CurrentParams.mockUserId || '';

export const userRequest = () => Request.fetch({
    url: 'api/cloudvideo/user/info/get',
    method: 'post',
    data: {
        mockUserId
    }
});

// https://nei.hz.netease.com/interface/detail/res/?pid=16038&id=149210
export const userAuthInfo = () => Request.fetch({
    url: '/api/user/creator/authinfo/get'
});

// 获取用户参与现金激励个人版，公司版的情况
export const cashEncourageStateRequest = () => Request.fetch({
    url: '/api/cloudvideo/activity/moneyexcite/userstate'
});



// WEBPACK FOOTER //
// ./client/util/userinfo.js